<template>
<a-modal v-model="showModal" :title="title"  width="88%" :footer="null"
 :maskClosable="false" :dialogStyle="{top: '6%'}" 
      @cancel="handleCancel">
        <a-table
            :columns="showColumns" 
            :data-source="datas" 
            :pagination="false"
            :rowKey="(record,i)=>{return i}"
            size="small" 
            style="height:360px;overflow-y:auto;"
          > 
          <div slot="status" slot-scope="text, record">
              <span v-if="record.status1 == 0">正常</span>
              <span v-else-if="record.status1 == 1">已停用</span>  
              <span v-else-if="record.status1 == 2">已退订</span>  
              <span v-else></span>   
          </div>
          <div slot="operation" slot-scope="text, record">
               <div v-if="$store.state.role != 1">
                   <span  v-if="showBtn(record)" class="row_record_cancel_btn" @click="cancel(record.order_num)">退订</span> 
               </div> 
          </div>
        </a-table>
   </a-modal>
</template>
<script>
import {errMsg, warnMsg,isNull, successMsg}  from "../../../utils/CommonUtils.js";
export default {
  props: ["tsid"],
  data() {
    return {
      title: "已购套餐",
      showModal: false,
      currentPage: 1, //当前页码, 默认1
      datas:[],
      showColumns: [
        {
          title: "订单编号",
          dataIndex: "order_num",
          width: 155,
        },
        {
          title: "开始时间",
          dataIndex: "start_time",
          width: 160,
        },
        {
          title: "结束时间",
          dataIndex: "end_time",
          width: 160,
        },
        {
          title: "下单时间",
          dataIndex: "order_time",
          width: 160,
        },
        {
          title: "下单账号",
          dataIndex: "createUser",
          ellipsis: true,
          width: 100,
        },
        {
          title: "套餐流量(KB)",
          dataIndex: "flow_count",
          width: 90,
        },
        {
          title: "已用流量(KB)",
          dataIndex: "used_flow",
           width: 90,
        },
        {
          title: "套餐国家",
          dataIndex: "countryCn",
          ellipsis: true,
          width: 80,
        },
         {
          title: "状态",
          dataIndex: "status1",
          scopedSlots: { customRender: "status" },
          width: 60,
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 60,
        },
      ],
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      if(isNull(this.tsid)){
          warnMsg("查询数据失败")
          return;
      }
      var reg = /^[0-9]{6,10}$/;
      if(!reg.test(this.tsid)){
         warnMsg("查询数据失败，tsid格式不正确")
         return; 
      }
      this.axios.post(this.baseUrl + "getHistoryData?tsid="+this.tsid, "",{headers:{token: sessionStorage.getItem("token")}}).then((res)=>{
        if(res.status == 200){
          if(res.data.code == 0){
              this.datas = res.data.data;
              this.showModal = true
          }else{
              this.$emit("history-visible", false); //不显示弹框
              if(res.data.code == -1){
                warnMsg("请先登录");
                setTimeout(() => {
                  this.$router.push({ name: "login" });
                }, "2000");
              }else if(res.data.code == -2){
                warnMsg("请稍后重试")
              }else if(res.data.code == -3){
                errMsg("系统异常,请联系客服")
              }else if(res.data.code == -4){
                warnMsg("请稍后重试")
              }
          }
        }else{
          warnMsg("查询失败,请稍后重试")
          this.$emit("history-visible", false);
        }
      }).catch(()=>{
          errMsg("系统异常,请联系客服")
          this.$emit("history-visible", false);
        })
    },
  
     handleCancel(){
        this.$emit("history-visible", false);
    },
    cancel(orderNum){
      var currentObj = this; //解决this指向问题
      this.$modal.confirm({
        content: "退订套餐?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          currentObj.axios.post(currentObj.baseUrl + "detail_cancel_order?orderNum=" + orderNum, "",{headers:{token: sessionStorage.getItem("token")}}).then((res)=>{
              if(res.status == 200){
                if(res.data.code == 0){
                  successMsg("退订成功")
                  currentObj.init()
                }else if(res.data.code == -1){
                  warnMsg("请先登录");
                  setTimeout(() => {
                    currentObj.$router.push({ name: "login" });
                  }, "2000");
                }else if(res.data.code == -3){
                  warnMsg("套餐信息异常")
                }else if(res.data.code == -4){
                  warnMsg("退订失败，请联系客服人员") 
                } else if(res.data.code == -7){
                  errMsg("系统异常,请联系客服")
                }  
              }else{
                warnMsg("查询失败,请稍后重试")
                currentObj.$emit("history-visible", false);
              }
            }).catch(()=>{
                errMsg("系统异常,请联系客服")
                currentObj.$emit("history-visible", false);
            })
        },
        onCancel() {
          warnMsg("已取消");
        },
      });
    },
    /** 是否显示退订按钮 */
    showBtn(record){
        /** 登录用户不等于订单创建用户就不显示退订 */
        if(record.createUser != sessionStorage.getItem("username")){
          return false;
        }

        let today = new Date();
        today.setHours(23);
        today.setMinutes(59);
        today.setSeconds(59);
        
        let date = record.start_time;
        date = date.substring(0,19);
        date = date.replace(/-/g,'/');
        let st = new Date(date).getTime();

        let date1 = record.end_time;
        date1 = date1.substring(0,19);
        date1 = date1.replace(/-/g,'/');
        let et = new Date(date1).getTime();

        /**不是客服账号(record.ifc != 1),可以参考order.vue文件里面的退订判断 */
        if (record.ifc != 1 && (record.status1 == 0 || record.status1 == 1) && ((record.start_time == "" && record.end_time == "") 
        || (st > today.getTime() && et > st)) && record.orderUser != 100) {
            return true;
        } else {
            return false;
        }
    }
  },
};
</script>
<style scoped>
.row_record_cancel_btn{
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  height: 25px;
  width: 40px;
  line-height: 25px;
  border: 1px solid rgb(182, 182, 182);
  color: rgb(56, 56, 56);
}
.row_record_cancel_btn:hover {
  cursor: pointer;
  color: rgb(39, 132, 255);
  border: 1px solid rgb(39, 132, 255);
}

.row_record_cancel_btn:active {
  color: rgb(0, 60, 255);
}

::v-deep .ant-modal-mask{
  background-color: rgb(0 0 0 / 15%) !important;
}
</style>